import React, { useState, useEffect, useMemo } from 'react';
import Select from 'react-select'
import * as styles from '../../../config/styles'

const HackedSelectFilterAttributeMulti = (props) => {
    const attribute = props.attribute
    const columnIndex = props.columnIndex
    const placeholder = (props.placeholder || 'Select Status...')
    const storageKey = props.localStorageKey
    const statusColumnIsMulti = props.statusColumnIsMulti

    const onChange = props.onChange
    
    const [ values, setValues ] = useState([])

    const options = useMemo(() => {
        const attr = attribute
        let options = []
        if( typeof attr.radio_button_values !== 'undefined' ) {
            options = attr.radio_button_values
        }
        else if( typeof attr.single_select_values !== 'undefined' ) {
            options = attr.single_select_values
        }
        options.map(status => status.label = status.value )
        return options
    }, [attribute])
    
    useEffect(() => {
        // If there's nothing stored in localStorage, keep values empty
        // empty values === all selected. Just cleaner
        let values = []
        try {
            values = JSON.parse(localStorage.getItem(storageKey))
            setValues(values)
            onChange(values)
        } catch(err) {
            values = []
        }
    },[localStorage.getItem(storageKey)])
    
    const updateValues = (data) => {
        setValues(data)
        onChange(data)
        localStorage.setItem(storageKey,JSON.stringify(data))
    }

    return (
        <div className="col-sm-6 m-b-xs">
            <Select
                key="select-filter-attribute-multi"
                isMulti={true}
                options={options}
                value={values}
                onChange={values => updateValues(values) }
                styles={styles.multiSelect}
                closeMenuOnSelect={false}
                placeholder={placeholder}
            />
        </div>
    )
}

export default HackedSelectFilterAttributeMulti
